import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import {
    BodyWrapper,
    CardBody,
    FlexContainer,
    IconsContainer,
    PaymentDetailsText,
    PaymentIconWrapper,
    RightIcon,
    ValidThruContainer,
    Wrapper
} from './PaymentMethodItem.style'

const VARIANTMAP: { [key: string]: string } = {
    mc: 'MASTERCARD',
    visa: 'VISA',
    directEbanking: 'KLARNA',
    klarna_paynow: 'KLARNA',
    sepa: 'SEPA',
    applepay: 'APPLE PAY',
    googlepay: 'GOOGLE PAY'
}

const getPaymentMethodIconUrl = (variant: string) => {
    if (VARIANTMAP[variant] !== undefined) {
        return `https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/${variant}.svg`
    }
    return ''
}

const formatExpiryDate = (expiryMonth: string, expiryYear: string) => {
    return `${expiryMonth.padStart(2, '0')}/${expiryYear}`
}

interface CardDetails {
    expiry_month: string
    expiry_year: string
    number: string
}

interface PaymentMethodItemProps {
    variant: string
    card: CardDetails
    onDelete: () => void
}

export const PaymentMethodItem: FC<PaymentMethodItemProps> = ({ variant, card, onDelete }) => {
    const formattedNumber = card && card.number ? `***** ${card.number}` : ''
    const { t } = useTranslation()

    return (
        <Wrapper>
            <CardBody>
                <BodyWrapper>
                    <PaymentIconWrapper>
                        <img src={getPaymentMethodIconUrl(variant)} />
                    </PaymentIconWrapper>
                    <FlexContainer>
                        <PaymentDetailsText>{`${VARIANTMAP[variant]} ${formattedNumber}`}</PaymentDetailsText>
                        {card && (
                            <ValidThruContainer>
                                {t('profile.paymentSection.validThru')}:{' '}
                                {formatExpiryDate(card.expiry_month, card.expiry_year)}
                            </ValidThruContainer>
                        )}
                    </FlexContainer>
                </BodyWrapper>
                <IconsContainer>
                    <RightIcon className="wemolo-ico-trash minor-hover-effect" onClick={onDelete} />
                </IconsContainer>
            </CardBody>
        </Wrapper>
    )
}
